import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { CheckboxModule } from 'primeng/checkbox';
import { ButtonModule } from 'primeng/button';
import { BadgeModule } from 'primeng/badge';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LogListComponent } from './log-list/log-list.component';
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { OverlayPanelModule } from "primeng/overlaypanel";
import { ConfirmPopupModule } from "primeng/confirmpopup";
import { DropdownModule } from "primeng/dropdown";
import { LogSelectorComponent } from "ng/src/app/logs/log-selector.component";
import { AutoCompleteModule } from "primeng/autocomplete";

@NgModule({
    declarations: [
        LogListComponent,
	    LogSelectorComponent
    ],
    imports: [
		CommonModule,
        FormsModule,
		TableModule,
		InputTextModule,
        CheckboxModule,
		ButtonModule,
		BadgeModule,
		MessageModule,
		MessagesModule,
        OverlayPanelModule,
        ConfirmPopupModule,
	    ReactiveFormsModule,
	    DropdownModule,
	    AutoCompleteModule
    ],
	exports: [
		LogSelectorComponent
	]
})
export class LogModule { }